import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const LanguageSelector = ({ currentLang, onChangeLang, languages }) => {
  const [isOpen, setIsOpen] = useState(false);
  const current = languages.find(l => l.code === currentLang) || languages[0];
  
  return (
    <div className="relative">
      <button 
        data-testid="language-selector"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1.5 px-2 py-1.5 bg-[var(--color-surface)]/60 border border-[var(--color-border)] hover:border-[var(--color-primary)] transition-colors text-sm"
      >
        <span className="text-sm">{current.flag}</span>
        <span className="text-xs font-medium text-[var(--color-text)] hidden sm:inline">{current.code.toUpperCase()}</span>
        <ChevronDown className="w-3 h-3 text-[var(--color-text-muted)]" />
      </button>
      {isOpen && (
        <div className="absolute top-full right-0 mt-1 bg-[var(--color-surface)] border border-[var(--color-border)] shadow-2xl shadow-black/50 z-50 w-[160px] max-h-[280px] overflow-y-auto">
          {languages.map(lang => (
            <button
              key={lang.code}
              data-testid={`lang-${lang.code}`}
              onClick={() => { onChangeLang(lang.code); setIsOpen(false); }}
              className={`w-full px-3 py-1.5 text-left hover:bg-[var(--color-surface-alt)] flex items-center gap-2 ${lang.code === currentLang ? 'bg-[var(--color-surface-alt)] text-white' : 'text-[var(--color-text-muted)]'}`}
            >
              <span className="text-sm">{lang.flag}</span>
              <span className="text-xs">{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
